import { type Role } from "@/lib/roles";

export interface TourStep {
  target: string;
  title: string;
  description: string;
  position: "top" | "bottom" | "left" | "right";
}

export const TOURS: Partial<Record<Role, TourStep[]>> = {
  admin: [
    { target: '[href="/"]', title: "Inicio", description: "Vista general del sistema con metricas clave.", position: "right" },
    { target: '[href="/programacion"]', title: "Programacion", description: "Gestiona la programacion semanal de abastecimiento para Bravo.", position: "right" },
    { target: '[href="/ordenes"]', title: "Ordenes", description: "Crea y gestiona ordenes de abastecimiento a productores.", position: "right" },
    { target: '[href="/siembras"]', title: "Siembras", description: "Registra y monitorea todas las siembras activas.", position: "right" },
    { target: '[href="/productores"]', title: "Productores", description: "Directorio de productores con fincas y contactos.", position: "right" },
    { target: '[href="/admin/usuarios"]', title: "Usuarios", description: "Asigna roles a los usuarios del sistema.", position: "right" },
  ],
  encargado_abastecimiento: [
    { target: '[href="/ordenes"]', title: "Ordenes", description: "Crea y gestiona ordenes de abastecimiento.", position: "right" },
    { target: '[href="/programacion"]', title: "Programacion", description: "Consulta la programacion semanal.", position: "right" },
    { target: '[href="/productores"]', title: "Productores", description: "Directorio de productores y contactos.", position: "right" },
    { target: '[href="/siembras"]', title: "Siembras", description: "Monitorea las siembras activas.", position: "right" },
  ],
  logistica: [
    { target: '[href="/ordenes"]', title: "Ordenes", description: "Consulta las ordenes de abastecimiento.", position: "right" },
    { target: '[href="/programacion"]', title: "Programacion", description: "Revisa la programacion semanal.", position: "right" },
  ],
  recepcion: [
    { target: '[href="/ordenes"]', title: "Ordenes", description: "Gestiona la recepcion de ordenes.", position: "right" },
  ],
  tecnico_zona: [
    { target: '[href="/siembras"]', title: "Tus Siembras", description: "Aqui veras las siembras de tu zona asignada.", position: "right" },
    { target: '[href="/productores"]', title: "Productores", description: "Consulta los productores de tu zona.", position: "right" },
    { target: '[href="/programas"]', title: "Programas", description: "Ejecuta las actividades de los programas agronomicos.", position: "right" },
  ],
  desarrollador_regional: [
    { target: '[href="/productores"]', title: "Productores", description: "Gestiona productores de tu region.", position: "right" },
    { target: '[href="/siembras"]', title: "Siembras", description: "Monitorea siembras de tu region.", position: "right" },
    { target: '[href="/programas"]', title: "Programas", description: "Programas agronomicos activos.", position: "right" },
    { target: '[href="/programacion"]', title: "Programacion", description: "Programacion semanal de abastecimiento.", position: "right" },
  ],
  desarrollador_agro: [
    { target: '[href="/productores"]', title: "Productores", description: "Directorio de productores.", position: "right" },
    { target: '[href="/siembras"]', title: "Siembras", description: "Siembras activas y seguimiento.", position: "right" },
    { target: '[href="/programas"]', title: "Programas", description: "Programas agronomicos y actividades.", position: "right" },
  ],
  agronomo: [
    { target: '[href="/siembras"]', title: "Siembras", description: "Monitorea las siembras activas.", position: "right" },
    { target: '[href="/programas"]', title: "Programas", description: "Ejecuta actividades de programas.", position: "right" },
    { target: '[href="/productores"]', title: "Productores", description: "Consulta el directorio de productores.", position: "right" },
  ],
  finanzas: [
    { target: '[href="/ordenes"]', title: "Ordenes", description: "Revisa ordenes y costos de abastecimiento.", position: "right" },
    { target: '[href="/productores"]', title: "Productores", description: "Consulta informacion de productores.", position: "right" },
  ],
  cliente_bravo: [
    { target: '[href="/bravo"]', title: "Portal Bravo", description: "Tu portal con programacion, trazabilidad y alertas.", position: "right" },
  ],
};
